import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Web3ProviderWrapper } from './contexts/Web3Context'
import { StatsProvider } from './contexts/StatsContext'
import Dashboard from './pages/Dashboard'

function App() {
  return (
    <Web3ProviderWrapper>
      <StatsProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-slate-950 text-white">
            <Routes>
              <Route path="/*" element={<Dashboard />} />
            </Routes>
          </div>
        </BrowserRouter>
      </StatsProvider>
    </Web3ProviderWrapper>
  )
}

export default App
